import { render, staticRenderFns } from "./the-header.vue?vue&type=template&id=354fa7b6&scoped=true"
import script from "./the-header.vue?vue&type=script&lang=js"
export * from "./the-header.vue?vue&type=script&lang=js"
import style0 from "./the-header.vue?vue&type=style&index=0&id=354fa7b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354fa7b6",
  null
  
)

export default component.exports